import React from 'react';
import type { SortState } from '../utils/useSort';

// Shared sortable table header cell, matching the Receiving Log header style:
// uppercase wash header, sticky top, click to sort, twin caret indicator.

function SortIcon({ active, direction }: { active: boolean; direction: string }) {
  return (
    <span className="inline-flex items-center ml-1">
      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" className={active ? 'text-teal-600' : 'text-[#C4C5CC]'}>
        <path d="M5 2L8 6H2L5 2Z" fill={active && direction === 'asc' ? 'currentColor' : '#D1D5DB'} />
        <path d="M5 8L2 4H8L5 8Z" fill={active && direction === 'desc' ? 'currentColor' : '#D1D5DB'} />
      </svg>
    </span>
  );
}

interface SortableThProps {
  label: string;
  column?: string;        // sort key; omit for non-sortable columns (e.g. Actions)
  sort: SortState;
  onSort: (column: string) => void;
}

export function SortableTh({ label, column, sort, onSort }: SortableThProps) {
  const sortable = column != null;
  const active = sortable && sort.column === column;
  return (
    <th
      onClick={() => sortable && onSort(column!)}
      className={`text-left text-xs font-semibold uppercase tracking-wide px-2 py-2 border-b border-trim whitespace-nowrap bg-wash sticky top-0 z-10 ${sortable ? 'cursor-pointer hover:bg-[#E9F0F0] select-none' : ''}`}
      style={{ color: '#73747A' }}
    >
      <span className="flex items-center">
        {label}
        {sortable && <SortIcon active={active} direction={sort.direction} />}
      </span>
    </th>
  );
}
